import clsx from 'clsx'
import {FC} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {checkIsActive, KTIcon} from '../../../helpers'

type NavItem = {
  to: string
  title: string
  icon: string
}

const items: NavItem[] = [
  {to: '/pedidos', title: 'Pedidos', icon: 'bi-receipt'},
  {to: '/produtos', title: 'Produtos', icon: 'element-11'},
  {to: '/clientes', title: 'Clientes', icon: 'bi-people-fill'},
  {to: '/usuarios', title: 'Usuários', icon: 'profile-circle'},
]

const renderIcon = (icon: string, active: boolean) => {
  const colorClass = active ? 'text-primary' : 'text-gray-500'
  if (icon.startsWith('bi')) {
    return <i className={clsx('bi fs-2', icon, colorClass)}></i>
  }
  return <KTIcon iconName={icon} className={clsx('fs-2', colorClass)} />
}

const MobileBottomNav: FC = () => {
  const {pathname} = useLocation()

  return (
    <>
      {/* Espaçador para o conteúdo não ficar escondido atrás da barra */}
      <div className='d-lg-none' style={{height: 'calc(60px + env(safe-area-inset-bottom))'}} />
      <div
        className='d-flex d-lg-none bg-body border-top position-fixed bottom-0 start-0 end-0'
        style={{zIndex: 105, paddingBottom: 'env(safe-area-inset-bottom)'}}
        id='kt_app_mobile_bottom_nav'
      >
        {items.map((item) => {
          const active = checkIsActive(pathname, item.to)
          return (
            <Link
              key={item.to}
              to={item.to}
              className='d-flex flex-column align-items-center justify-content-center flex-grow-1 py-2 text-decoration-none'
            >
              {renderIcon(item.icon, active)}
              <span className={clsx('fs-8 mt-1', active ? 'text-primary fw-bold' : 'text-gray-500')}>
                {item.title}
              </span>
            </Link>
          )
        })}
        <div
          id='kt_app_sidebar_mobile_toggle'
          className='d-flex flex-column align-items-center justify-content-center flex-grow-1 py-2 cursor-pointer'
        >
          <i className='bi bi-list fs-2 text-gray-500'></i>
          <span className='fs-8 mt-1 text-gray-500'>Menu</span>
        </div>
      </div>
    </>
  )
}

export {MobileBottomNav}
